import React from 'react';

const SATUpsellContent: React.FC = (props) => {
  return (
    <ul className="u-padding-L-m">
      <li>Digital SAT ready</li>
      <li>1750+ practice questions</li>
      <li>Video and/or text explanations</li>
      <li>Up to 3 practice tests</li>
      <li>200+ video lessons</li>
      <li>Study schedules</li>
      <li>Data-driven score prediction</li>
    </ul>
  );
};

export default SATUpsellContent;
